import { CancelIcon, InfoIcon, SuccessIcon } from "@teamworksdev/icons";
import type { CustomerFacingApp } from "@teamworksdev/react";
import { colors } from "@teamworksdev/style";
import type { ReactNode } from "react";
import { AppLogoWithIconBadge } from "../IconBadge";
import { WithTooltip } from "../Tooltip";

export type StatusVariant = "success" | "error" | "disabled";

type StatusIndicatorProps = {
  variant: StatusVariant;
  teamName?: string;
  appName: string;
  appSlug: CustomerFacingApp;
};

export const StatusIndicator = ({ variant, teamName, appName, appSlug }: StatusIndicatorProps) => {
  let statusIcon: ReactNode = null;
  let subtext: string | null = null;

  switch (variant) {
    case "success":
      statusIcon = <SuccessIcon height={10} width={10} color={colors.success[700]} />;
      subtext = `Mapped to ${teamName}`;
      break;
    case "error":
      statusIcon = <CancelIcon height={10} width={10} color={colors.error[700]} />;
      subtext = "Mapping Broken";
      break;
    default:
      statusIcon = <InfoIcon height={10} width={10} color={colors.light[500]} />;
      subtext = "Not mapped";
  }

  return (
    <WithTooltip title={appName} subtext={subtext}>
      <AppLogoWithIconBadge aria-label={subtext} variant={variant} app={appSlug}>
        {statusIcon}
      </AppLogoWithIconBadge>
    </WithTooltip>
  );
};
